import { Button, Col } from "@/components";
import clsx from "clsx";
import "./BottomNavigation.scss";

type BottomNavigationProps = {
  className?: string;
  title: string;
  removeLabel: string;
  applyLabel: string;
  selectedFilters: Record<string, string[]>;
  onApplyFilters: () => void;
  onClearFilters: () => void;
  applyDisabled?: boolean;
};

export const BottomNavigation = ({
  className = "",
  title,
  removeLabel,
  applyLabel,
  selectedFilters,
  onApplyFilters,
  onClearFilters,
  applyDisabled = false,
}: BottomNavigationProps) => {
  const countFilters = Object.values(selectedFilters).reduce(
    (total, filters) => total + filters.length,
    0,
  );
  return (
    <Col gap={"x24"} className={clsx(className)}>
      <h2 className={"fw-semibold fs-5 text-slate-20"}>
        {title} ({countFilters})
      </h2>
      <footer className="ui-bottom-navigation-filters">
        <Button
          className={"ui-bottom-navigation-filters-button"}
          variant={"secondary"}
          onClick={onClearFilters}
          disabled={countFilters === 0}
        >
          {removeLabel}
        </Button>
        <Button
          className={"ui-bottom-navigation-filters-button"}
          disabled={applyDisabled}
          onClick={onApplyFilters}
        >
          {applyLabel}
        </Button>
      </footer>
    </Col>
  );
};
